export default __webpack_public_path__ + "static/media/geodoc-background.02211c91.png";